/**
 * React hook to handle success with snackbar
 */

import { useEffect, useState } from 'react';

import { Staff } from '../../../services/staff/types';
import { Student } from '../../../services/students/types';
import { useGetCurrentUserQuery } from '../../../services/users';
import { PermissionType } from '../../../types/common';

const getPermissionsArray = (userData: Student | Staff | undefined) => {
  if (userData) {
    const notePermissions = (userData.notePermissions || []).map((x) => x.value);
    const videoPermissions = (userData.videoPermissions || []).map((x) => x.value);
    const tutorialPermissions = (userData.tutorialPermissions || []).map((x) => x.value);
    const examPermissions = (userData.examPermissions || []).map((x) => x.value);

    const permissions = [
      ...(userData.hasMasterAccess ? [PermissionType.Base] : []),
      ...notePermissions,
      ...videoPermissions,
      ...tutorialPermissions,
      ...examPermissions,
    ];

    return permissions;
  }
  return undefined;
};

const useUserPermissions = () => {
  const { data: currUser } = useGetCurrentUserQuery();
  const [userPermissions, setUserPermissions] = useState<string[] | undefined>(
    getPermissionsArray(currUser?.data),
  );

  useEffect(() => {
    setUserPermissions(getPermissionsArray(currUser?.data));
  }, [currUser]);

  return userPermissions;
};

export default useUserPermissions;
